var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtherscan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20356_10920)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20356_10920",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_20356_10920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53229 11.3982C5.53231 11.2657 5.55852 11.1345 5.60938 11.0121C5.66025 10.8898 5.73479 10.7787 5.82872 10.6852C5.92267 10.5917 6.03412 10.5177 6.15674 10.4674C6.27935 10.4171 6.41069 10.3916 6.54322 10.3922L8.21932 10.3976C8.48653 10.3976 8.74283 10.5038 8.93178 10.6928C9.12076 10.8817 9.22692 11.138 9.22692 11.4053V17.7428C9.41561 17.6868 9.65795 17.6271 9.92312 17.5647C10.1073 17.5214 10.2715 17.4172 10.389 17.2689C10.5065 17.1206 10.5704 16.9369 10.5703 16.7477V8.88623C10.5703 8.61897 10.6765 8.36266 10.8654 8.17367C11.0544 7.98467 11.3107 7.87849 11.5779 7.87843H13.2574C13.5246 7.87849 13.7809 7.98467 13.9699 8.17367C14.1588 8.36266 14.265 8.61897 14.265 8.88623V16.1824C14.265 16.1824 14.6855 16.0123 15.095 15.8394C15.2472 15.7751 15.377 15.6673 15.4683 15.5297C15.5597 15.392 15.6084 15.2305 15.6086 15.0654V6.36721C15.6086 6.10001 15.7147 5.84373 15.9036 5.65478C16.0925 5.46582 16.3488 5.35966 16.616 5.3596H18.2954C18.5627 5.3596 18.8189 5.46574 19.0079 5.65472C19.1969 5.84368 19.303 6.09997 19.303 6.36721V13.5299C20.759 12.4747 22.2345 11.2056 23.4055 9.6796C23.5754 9.45809 23.6878 9.19798 23.7327 8.92249C23.7776 8.64699 23.7536 8.36465 23.6628 8.10067C23.1208 6.54122 22.2593 5.11207 21.1333 3.90469C20.0072 2.69733 18.6415 1.73832 17.1236 1.08905C15.6057 0.439773 13.9689 0.114532 12.3181 0.134137C10.6672 0.153742 9.03865 0.517763 7.53658 1.2029C6.0345 1.88804 4.69198 2.87921 3.59494 4.11298C2.49791 5.34674 1.67052 6.79595 1.16572 8.36785C0.660916 9.93973 0.489822 11.5997 0.663383 13.2415C0.836944 14.8833 1.35134 16.4708 2.17365 17.9024C2.3169 18.1494 2.52765 18.3503 2.78113 18.4817C3.03461 18.613 3.32031 18.6693 3.60468 18.6439C3.92234 18.616 4.31785 18.5764 4.7881 18.5212C4.9928 18.4979 5.18179 18.4002 5.31906 18.2466C5.45635 18.0929 5.53231 17.8942 5.53249 17.6882L5.53229 11.3982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49619 21.5631C7.26639 22.8509 9.35839 23.624 11.5407 23.7967C13.723 23.9692 15.9105 23.5348 17.8613 22.5413C19.812 21.5477 21.4497 20.0339 22.5935 18.1674C23.7371 16.3008 24.3422 14.1541 24.3416 11.965C24.3416 11.6918 24.3289 11.4216 24.3108 11.1529C19.9754 17.6189 11.9705 20.6418 5.49656 21.5621",
    fill: "black"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20356_10920)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20356_10920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_20356_10920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtherscan);
export default __webpack_public_path__ + "static/media/etherscan.ae0ee28f54866fe8c0b87ee6e95639ed.svg";
export { ForwardRef as ReactComponent };